<template>
	<div class="chat-container w-100 position-relative bg-white hide-scroll" >
  	<top-navbar title="Orders History" :url="`/${getMerchant().code}/account`" />
  	<div class="w-100" style="height:60px;"></div>
  	<div class="container pt-4" style="min-height: calc(100vh - 134px);">
  		<blank-page
         v-if="session.is_exp || session.is_null"
        :title="session_msg"
        :message="$t('restaurant.exp-session.desc')"
        :btn_primary="$t('restaurant.exp-session.btn')"
        @primary="goToHome" />
      <template v-else>
	  		<div v-if="is_load" class="w-100 text-center mt-5">
	  			<loader />
	  		</div>
	  		<template v-else>
	  			<template v-if="error != '' || error_bill != ''">
		  			<ErrorMessage v-if="error != ''" :message="error"></ErrorMessage>
		  			<ErrorMessage v-if="error_bill != ''" :message="error_bill"></ErrorMessage>
	  			</template>
	  			<template v-else>
	        	<p class="body-2 mb-4 w-75 text-center mx-auto" v-if="data_list.length == 0">{{$t('restaurant.order-history-empty')}}</p>
	        	<template v-else>
	        		<UnpaidBill />
              <div classs="mb-3" v-for="(data, index) in data_list">
                <OrderHistoryItem :data="data" />
              </div>
	        	</template>
	  			</template>
	  		</template>
	  	</template>
  	</div>
    <BottomNavbar page="HISTORY" />
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import {formatCurrency, formatDate} from '@/utils/index.js';
  import moment from 'moment';
	import BlankPage from "@/components/general/BlankPage";
	import UnpaidBill from '@/components/restaurant-v2/unpaidBill'
  import OrderHistoryItem from '../../components/restaurant-v2/OrderHistoryItem.vue';
  import BottomNavbar from '../../components/restaurant-v2/BottomNavbar.vue';

  export default{
  	components:{
  		BlankPage,
  		UnpaidBill,
      OrderHistoryItem,
      BottomNavbar
  	},
  	data(){
  		return{
  			data_list: [],
  			error: '',
  			error_bill: '',
  			is_load: true,
  			session:{
  				is_exp: false,
  				is_null: false
  			}
  		}
  	},
  	computed:{
  		session_msg(){
  			let data = this.session.is_exp ? this.$t('restaurant.exp-session.title-2') : this.$t('restaurant.exp-session.title-1')
  			return data
  		}
  	},
  	mounted(){
  		// this.loadFirstData()
      this.getOrderHistoryList()
  	},
  	methods:{
      ...mapGetters(['getMerchant','getRestaurantAuth']),
      ...mapMutations(['setRestaurantAuth']),
      formatDate(date){
				return moment(date).format('hh:mm, DD MMM YYYY');
			},
      formatCurrency(data) {
        return formatCurrency(data);
      },
      convertStatus(status){
      	let data = {
					class_name : 'text-orange',
					text : this.$t('hotel.concierge.waiting')
				}
				if(status == 'PENDING'){
          data.class_name = 'text-orange'
          data.text = this.$t('hotel.concierge.waiting')
        }else if(status == 'ONPROGRESS'){
          data.class_name = 'text-info'
          data.text = this.$t('hotel.concierge.on-progress')
        }else if(status == 'COMPLETE'){
          data.class_name = 'text-green'
          data.text =  this.$t('hotel.concierge.complete')
        }else if(status == 'CANCELLED'){
          data.class_name = 'text-danger'
          data.text = this.$t('hotel.concierge.cancelled')
        }else{
          data.class_name = 'text-warning'
          data.text = status
        }
				return data
      },
      goToDetail(id){
      	this.$router.push(`/${this.getMerchant().code}/r/order-history/${id}`)
      },
      goToHome(){
	      this.$router.push({
	        path: "/" + this.getMerchant().code,
	      });
	    },
	    goToBillPage(){
	    	this.$router.push({
	        path: "/" + this.getMerchant().code + "/r/payment-bill",
	      });
	    },
      loadFirstData(){
      	if(this.getRestaurantAuth().session != ''){
      		this.validateSession().then(res=>{
      			if(res){
      				this.getOrderHistoryList()
      			}else{
      				this.is_load = false
      			}
      		})
      	}else{
      		this.is_load = false
      		this.session.is_null = true
      	}
      },

      validateSession(){
	    	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/validate",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(res.success){
							done(true)
						}else{
							let params = [
								{
									key: 'name',
					    		value: ''	
								},
								{
									key: 'session',
					    		value: ''	
								},
							]
							this.setRestaurantAuth(params)
							this.session.is_exp = true 
							done(false)
						}
					})
	    	})
	    },
      getOrderHistoryList(){
      	return new Promise(done=>{
					this.is_load = true
					this.error = ''
					this.data_list = []
					let params = {
	          status: 'ALL',
	          order_type: 'ASC',
	          datetime_type: 'NO_USE_FILTER_DATE',
	          start_datetime: moment().format("YYYY-MM-DD")+" 00:00:00",
	          end_datetime: moment().format("YYYY-MM-DD")+" 00:00:00",
	          page_size: 100,
	          page: 1,
	          merchant_id: this.getMerchant().id
	        }
					get("CORE_RESTO","v2/tx-history",params,"restaurant_session").then(response=>{
						let res = response.data
						if(res.success != false){
              if(this.$isNotEmpty(res.data))
							this.data_list = res.data.filter(trx => trx.tx_type === 'ORDER');
							done(true)
						}else{
							this.error = res.message
							done(res.message)
						}
						this.is_load = false
					})
				})
      },
  	}
  }

</script>


// WEBPACK FOOTER //
// src/pages/restaurant/OrderHistory.vue